import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import ForgottenPassword from '../views/ForgottenPassword.vue';
import VerifyEmail from '../views/VerifyEmail.vue';
import Home from '../views/Home.vue';
import Documents from '../views/Documents.vue';
import Dashboard from '../views/Dashboard.vue';
import Content from '../views/Content.vue';
import Users from '../views/Users.vue';
import Exercises from '../views/Exercises.vue';
import Workouts from '../views/Workouts.vue';
import Challenges from '../views/Challenges.vue';
import Brands from '../views/Brands.vue';
import Tags from '../views/Tags.vue';
import ContentEditor from '../views/ContentEditor.vue';
import ContentEditorDetails from '../views/ContentEditorDetails.vue';
import Promotional from '../views/Promotional.vue';
import Feedback from '../views/Feedback.vue';
import Reports from '../views/Reports.vue';
import UserReports from '../views/UserReports.vue';
import About from '../views/About.vue';
import ChallengeManagement from '../views/ChallengeManagement.vue';
import Settings from '../views/Settings.vue';
import Blog from '../views/Blog.vue';
import BlogPage from '../views/BlogPage.vue';
import { isAuthed } from '@/utils'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/promo',
    name: 'Promo',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/forgotten_password',
    name: 'ForgottenPassword',
    component: ForgottenPassword,
  },
  {
    path: '/app/dashboard',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/app/content',
    name: 'Content',
    component: Content,
  },
  {
    path: '/app/users',
    name: 'Users',
    component: Users,
  },
  {
    path: '/app/workouts',
    name: 'Workouts',
    component: Workouts,
  },
  {
    path: '/app/exercises',
    name: 'Exercises',
    component: Exercises,
  },
  {
    path: '/app/challenges',
    name: 'Challenges',
    component: Challenges,
  },
  {
    path: '/app/challenge_management',
    name: 'ChallengeManagement',
    component: ChallengeManagement,
  },
  {
    path: '/app/brands',
    name: 'Brands',
    component: Brands,
  },
  {
    path: '/app/tags',
    name: 'Tags',
    component: Tags,
  },
  {
    path: '/app/content_editor',
    name: 'ContentEditor',
    component: ContentEditor,
  },
  {
    path: '/app/content_editor/:type',
    name: 'ContentEditorDetails',
    component: ContentEditorDetails,
  },
  {
    path: '/app/promotional',
    name: 'Promotional',
    component: Promotional,
  },
  {
    path: '/app/feedback',
    name: 'Feedback',
    component: Feedback,
  },
  {
    path: '/app/reports',
    name: 'Reports',
    component: Reports,
  },
  {
    path: '/app/user_reports/:userId',
    name: 'UserReports',
    component: UserReports,
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Documents,
    props: { type: 'privacy' }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Documents,
    props: { type: 'terms' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
  },
  {
    path: '/blog/:id',
    name: 'BlogPage',
    component: BlogPage,
  },
  {
    path: '/verify_email',
    name: 'VerifyEmail',
    component: VerifyEmail,
  },
  {
    path: '/app/settings',
    name: 'Settings',
    component: Settings,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

let unauthedRoutes = [
  'Home',
  'Login',
  'ForgottenPassword',
  'VerifyEmail',
  'Promo',
  'Privacy',
  'Terms',
  'About',
  'Blog',
  'BlogPage',
];

router.beforeEach((to, from, next) => {
  if (!isAuthed()) {
    // unauthed
    if (unauthedRoutes.includes(to.name)) {
      next();
    } else {
      next('/');
    }
  } else {
    // authed
    if (unauthedRoutes.includes(to.name)) {
      next('/app/dashboard');
    } else {
      next();
    }
  }
});

export default router;
